import { legacy_createStore as createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import Loginreducer from './reducer/loginreducer';
import Userlist from './reducer/userlistreducer';
import GetBlog from './reducer/Blogreducer';
import GetEmployer from './reducer/Employerreducer';
import GetEmployee from './reducer/Employeereducer';
import GetAdmin from './reducer/Adminreducer';
import Getticket from './reducer/Ticketreducer';
import Gettransaction from './reducer/Transactionreducer';

const rootReducer = combineReducers({
  Login: Loginreducer,
  User: Userlist,
  Employer: GetEmployer,
  Blog: GetBlog,
  Salary: GetEmployee,
  Admin: GetAdmin,
  Ticket: Getticket,
  Transaction: Gettransaction,
});
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
